
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { AloDbFleetConfig } from '@/models/alodb/AloDbFleetConfig';
import { FilterFleet } from '@/models/filter/FilterFleet';

export interface IAdminFleetState {
    status:string
    adminFleetsId: Array<number>
    adminFleetsById: Record<number, AloDbFleet>
    //adminFleets: Array<AloDbFleet>
    modifiedAdmAdminFleet: AloDbFleet
    originalAdmAdminFleet: AloDbFleet
    adminFleetLoading: boolean
    adminFilter: FilterFleet
    configsFleet:  Array<AloDbFleetConfig>
    currentConfig: AloDbFleetConfig
    histoConfig: AloDbFleetConfig    
}
  
const state:IAdminFleetState = { 
    status: '',
    adminFleetsId: [],
    adminFleetsById: {},
    modifiedAdmAdminFleet: new AloDbFleet(),
    originalAdmAdminFleet: new AloDbFleet(),
    adminFleetLoading:false,
    adminFilter: new FilterFleet(),
    configsFleet:[],
    currentConfig: new AloDbFleetConfig(),
    histoConfig: new AloDbFleetConfig()
}
  
export default state